/**
 * This  is a simple helper function to check if a given date is between two other dates
 */

import { isBefore, isAfter, isEqual } from 'date-fns';

export default (date, start, end) => (isBefore(date, end) && isAfter(date, start))
  || (isEqual(date, start))
  || (isEqual(date, end));
